export class SeachQuery {
    pageNo: number;
    pageSize: number;
    bondNo: string;
}